import { render } from "./error403Page.vue?vue&type=template&id=6c70bcb8&scoped=true"
const script = {}

import "./error403Page.vue?vue&type=style&index=0&id=6c70bcb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c70bcb8"]])

export default __exports__